module.exports = __webpack_public_path__ + "static/teddybike1-d7847690779c1acb79686683bd022168.png";